const IconCheck = ({ size, width, height, color, ...props }) => (
    <svg
        width={width || size}
        height={height || size}
        viewBox="0 0 15 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.9846 1.66016C14.9846 1.94141 14.8596 2.19141 14.6721 2.37891L6.67212 10.3789C6.48462 10.5664 6.23462 10.6602 5.98462 10.6602C5.70337 10.6602 5.45337 10.5664 5.26587 10.3789L1.26587 6.37891C1.07837 6.19141 0.984619 5.94141 0.984619 5.66016C0.984619 5.09766 1.42212 4.66016 1.98462 4.66016C2.23462 4.66016 2.48462 4.78516 2.67212 4.97266L5.98462 8.25391L13.2659 0.972656C13.4534 0.785156 13.7034 0.660156 13.9846 0.660156C14.5159 0.660156 14.9846 1.09766 14.9846 1.66016Z"
            fill={color}
        />
    </svg>
);

export default IconCheck;
